import type { DiseaseType, FindingType } from "../mappers";
import { NaiveBayesDiseaseModel } from "./disease-prediction-model";
import { LookupFirstRecommender } from "./lookup-first-recommender";
import { ModelBasedRecommender } from "./model-based-recommender";

const DISEASE_PROBABILITY_THRESHOLD = 0.08; // 8% threshold was determined through testing to achieve optimal model performancee, more info here: https://elephant.slab.com/posts/fever-guide-test-recommendations-doodling-e5zvxn56#hmtah-final-strategy-naive-bayesian-prediction-using-qualitative-symptom-likelihoods-and-a-disease-probability-threshold

export interface DiseaseRecommender {
  recommend: (findings: FindingType[]) => DiseaseType[];
}

export const model = new NaiveBayesDiseaseModel();
export const modelBasedRecommender = new ModelBasedRecommender(
  model,
  DISEASE_PROBABILITY_THRESHOLD,
);
export const diseaseRecommender = LookupFirstRecommender.fromMappings(
  modelBasedRecommender,
);
